import { Ban } from 'lucide-react';
import { cn } from '@/lib/utils';
import { MinisterPhoto } from './MinisterPhoto';

interface BallotCandidateCardProps {
  name: string;
  photoFilename?: string | null;
  /** The "Voto en blanco" card */
  blank?: boolean;
  onSelect: () => void;
  disabled?: boolean;
}

/** Big tap target for elderly voters: large photo, large name, no small print */
export function BallotCandidateCard({ name, photoFilename, blank, onSelect, disabled }: BallotCandidateCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      className={cn(
        'flex min-h-[220px] flex-col items-center justify-center gap-4 rounded-2xl border-4 bg-card p-6 text-center shadow-sm transition',
        'hover:border-primary hover:shadow-lg focus:outline-none focus-visible:ring-4 focus-visible:ring-primary active:scale-[0.98] disabled:opacity-50',
        blank && 'border-dashed bg-muted/40',
      )}
    >
      {blank ? (
        <div className="flex size-36 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Ban className="size-16" aria-hidden />
        </div>
      ) : (
        <MinisterPhoto filename={photoFilename} name={name} className="size-36" />
      )}
      <span className="text-2xl font-bold leading-tight">{name}</span>
    </button>
  );
}
